import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // ✅ i18n
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import SearchBar from './SearchBar';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = ({
  user,
  isAdminPath,
  isMenuOpen,
  setIsMenuOpen,
  closeAll,
  subservices,
  categories,
  showCallModal,
  setShowCallModal,
  unreadCount,
  isNotifOpen,
  setIsNotifOpen,
  markAsRead,
  lastOrders,
  statusTranslations,
  navigate,
  openCat,
  setOpenCat,
  userBtnStyle,
  faCalculator
}) => {
  const { t } = useTranslation(); // ✅ i18n hook

  if (isAdminPath) return null;

  const goldColor = '#b08d4a';
  const darkBlue = '#0f172a';

  return (
   <header 
  className="navbar-modern" 
  style={{ 
    zIndex: 1000,
    position: 'fixed', // ✅ Սա կստիպի, որ ինքը տեղ զբաղեցնի ու կոնտենտը չմտնի տակը
    top: 0,
    background: '#fff',
    display: 'block',
    width: '100%',
    marginBottom:'10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  }}
>
      <div className="nav-top-row">
        <div className="nav-inner main-header-flex">
          <div className="nav-left-group">
            <button className="hamburger-btn mobile-only" aria-label={isMenuOpen ? "Close menu" : "Open menu"} onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ color: darkBlue }}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
            <Link to="/" className="logo-main" onClick={closeAll} style={{ color: darkBlue, textDecoration: 'none', fontWeight: '900', fontSize: '22px' }}>
              LIBER <span style={{ color: goldColor }}>GROUP</span>
            </Link>
          </div>

          <div className="search-container-center desktop-only">
            <SearchBar subservices={subservices} />
          </div>

          <div className="nav-right-actions">
            <div className="desktop-only nav-auth-section">
              {user ? (
                <Link to="/profile" className="btn-user-profile" style={{ ...userBtnStyle, borderColor: goldColor, color: goldColor }}>
                  <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }} /> <span>{t('my_profile_btn')}</span>
                </Link>
              ) : (
                <Link to="/user-login" className="btn-auth-link" style={{ ...userBtnStyle, background: goldColor, color: '#fff', border: `1px solid ${goldColor}` }}>
                  {t('login_btn')}
                </Link>
              )}
            </div>

            {/* ✅ Desktop Language Switcher */}
            <div className="desktop-only" style={{ marginLeft: '10px', marginRight: '10px', minWidth: '100px' }}>
              <LanguageSwitcher />
            </div>

          <button 
  className="btn-call-desktop desktop-only" 
  aria-label={t('contact_btn')} // ✅ Ավելացրու սա
  onClick={() => setShowCallModal(true)} 
  style={{ ...userBtnStyle, color: goldColor, borderColor: goldColor }}
>
  <FontAwesomeIcon icon={faPhone} style={{ marginRight: '8px' }} /> 
  <span>{t('contact_btn')}</span>
</button>

            <div className="notif-wrapper" style={{ position: 'relative' }}>
              <button 
                className="notification-bell-btn"
                aria-label="Toggle notifications"
                onClick={(e) => {
                  e.stopPropagation(); 
                  if (!user) return;
                  if (!isNotifOpen && unreadCount > 0) {
                    if (typeof markAsRead === 'function') markAsRead();
                  }
                  setIsNotifOpen(!isNotifOpen); 
                }}
                style={{ background: 'none', border: 'none', position: 'relative', cursor: 'pointer', fontSize: '22px', padding: '5px' }}
              >
                <FontAwesomeIcon 
                  icon={faBell} 
                  className={unreadCount > 0 ? "bell-ring-active" : ""} 
                  style={{ color: unreadCount > 0 ? goldColor : '#64748b' }}
                />
                {unreadCount > 0 && (
                  <span style={{
                    position: 'absolute', top: '0px', right: '0px',
                    background: goldColor, color: 'white', borderRadius: '50%',
                    padding: '2px 6px', fontSize: '10px', fontWeight: 'bold',
                    border: '2px solid white'
                  }}>{unreadCount}</span>
                )}
              </button>

              {isNotifOpen && (
                <div className="notif-dropdown" style={{
                  position: 'absolute', top: '50px', right: '0',
                  width: '320px', background: 'white', borderRadius: '20px',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.15)', zIndex: 100001,
                  border: `1px solid #f1f5f9`, overflow: 'hidden'
                }}>
                  <div style={{ padding: '18px', fontWeight: '800', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
                    <span style={{ color: darkBlue, fontSize: '14px', letterSpacing: '0.5px' }}>{t('notifications_header')}</span>
                    <button onClick={() => setIsNotifOpen(false)} aria-label="Close notifications" style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#94a3b8', padding: '5px' }}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>

                  <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    {lastOrders && lastOrders.length > 0 ? (
                      lastOrders.slice(0, 10).map((item, idx) => {
                        const isOrder = !!(item.service_name || item.orderId || item.type === 'order');
                        const isUnread = Number(item.is_read) === 0;

                        return (
                          <div 
                            key={`notif-${item.id || idx}`} 
                            style={{ 
                              padding: '15px', 
                              borderBottom: '1px solid #f8fafc', 
                              background: isUnread ? 'rgba(197, 160, 89, 0.06)' : 'white', 
                              transition: '0.2s',
                              cursor: 'pointer'
                            }}
                          >
                            <div style={{ fontWeight: '700', fontSize: '13px', color: darkBlue, marginBottom: '3px' }}>
                              {isOrder ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <span>📦</span>
                                  <span>{t('notif_order_label')}: <span style={{ color: goldColor }}>{item.service_name || t('notif_info')}</span></span>
                                </div>
                              ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <span>📢</span>
                                  <span style={{ color: '#ef4444' }}>{t('notif_announcement')}</span>
                                </div>
                              )}
                            </div>
                            
                            <div style={{ fontSize: '12px', color: '#475569', fontWeight: isUnread ? '600' : '500', lineHeight: '1.4' }}>
                              {isOrder ? (
                                <div>
                                  <span style={{ color: goldColor, textTransform: 'uppercase', fontSize: '11px' }}>
                                    {statusTranslations[item.status] || item.status || t('status_new')}
                                  </span>
                                  {item.message && <div style={{ color: '#64748b', fontSize: '11px', marginTop: '2px' }}>{item.message}</div>}
                                </div>
                              ) : (
                                <div style={{ color: '#1e293b' }}>{item.message || item.title}</div>
                              )}
                            </div>

                            <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '8px', display: 'flex', justifyContent: 'flex-end' }}>
                              {item.created_at ? new Date(item.created_at).toLocaleString() : ''}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div style={{ padding: '40px 20px', textAlign: 'center', color: '#94a3b8', fontSize: '13px' }}>
                        <div style={{ fontSize: '30px', marginBottom: '10px', opacity: 0.5 }}>🔔</div>
                        {t('no_new_notifications')}
                      </div>
                    )}
                  </div>

                  <button 
                    onClick={() => { navigate('/notifications'); setIsNotifOpen(false); }}
                    aria-label={t('see_all_notifications')}
                    style={{ width: '100%', padding: '16px', background: '#f8fafc', border: 'none', color: goldColor, fontWeight: '800', cursor: 'pointer', borderTop: '1px solid #f1f5f9', fontSize: '12px' }}
                  >
                    {t('see_all_notifications')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <nav className={`nav-bottom-links ${isMenuOpen ? 'open' : ''}`} style={{ zIndex: 100005 }}>
        <div className="nav-inner">
          <button className="drawer-close-btn mobile-only" aria-label="Close menu"  onClick={() => setIsMenuOpen(false)} style={{ color: goldColor }}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          
          <div className="nav-links-container">
            
            {/* ✅ Mobile Language Switcher - Full Width */}
            <div className="mobile-only language-switcher-mobile" style={{ 
              marginBottom: '15px', 
              display: 'flex', 
              width: '100%', 
              boxSizing: 'border-box'
            }}>
              <div style={{ 
                width: '100%', 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '12px',
                padding: '2px'
              }}>
                <LanguageSwitcher /> 
              </div>
            </div>

            {/* ✅ Mobile Search */}
            <div className="mobile-only mobile-search-box" style={{ 
              marginBottom: '25px', 
              position: 'relative', 
              zIndex: 900,
              width: '100%'
            }}>
              <SearchBar subservices={subservices} onResultClick={() => setIsMenuOpen(false)} />
            </div>

            <Link to="/" className="nav-item desktop-only" onClick={closeAll}>{t('nav_home')}</Link>
            <Link to="/portfolio" className="nav-item" onClick={closeAll}>{t('nav_projects')}</Link>
            <Link to="/about" className="nav-item" onClick={closeAll}>{t('nav_about')}</Link>
            <Link to="/favorites" className="nav-item desktop-only" onClick={closeAll}>{t('nav_favorites')}</Link>
            
            <div className="desktop-only dropdown-parent">
              <span className="nav-item">
                {t('nav_services')} 
                <FontAwesomeIcon icon={faChevronDown} style={{marginLeft: '5px', fontSize: '10px'}} />
              </span>
              <div className="mega-menu" style={{ borderTop: `4px solid ${goldColor}`, borderRadius: '0 0 20px 20px', zIndex: 100010 }}>
                {categories.map((cat, idx) => (
                  <div key={`cat-desktop-${cat.id}-${idx}`} className="mega-col">
                    <h4 style={{ color: goldColor, borderBottom: `1px solid rgba(197, 160, 89, 0.2)`, paddingBottom: '8px', marginBottom: '12px', fontSize: '14px' }}>{cat.name}</h4>
                    {subservices.filter(s => s.category_id === cat.id).map((sub, subIdx) => (
                      <Link key={`sub-desktop-${sub.id}-${subIdx}`} to={`/subservice/${sub.id}`} onClick={closeAll} style={{ fontSize: '13px' }}>{sub.name}</Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <Link to="/partners" className="nav-item" onClick={closeAll}>{t('nav_partners')}</Link>
            
            <Link to="/calculators" className="nav-item" onClick={closeAll}>
              <FontAwesomeIcon icon={faCalculator} style={{ marginRight: '8px' }} />
              {t('nav_calculators')}
            </Link>
            <Link to="/blog" className="nav-item" onClick={closeAll}>{t('nav_blog')}</Link>
            <Link to="/contact" className="nav-item desktop-only" onClick={closeAll}>{t('nav_contact')}</Link>

            <div className="mobile-only mobile-accordion-section">
              <p className="mobile-menu-title" style={{ 
                marginTop: '15px', borderTop: '1px solid rgba(255,255,255,0.1)', 
                paddingTop: '20px', color: goldColor, fontWeight: '800', letterSpacing: '1px' 
              }}>
                {t('nav_services')}
              </p>
              
              {categories.map((cat, idx) => {
                const isOpen = openCat === cat.id;
                return (
                  <div key={`cat-mobile-${cat.id}-${idx}`} className="mobile-cat-item">
                    <div className="mobile-cat-header" onClick={() => setOpenCat(isOpen ? null : cat.id)} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', cursor: 'pointer' }}>
                      <span style={{ color: isOpen ? goldColor : '#f1f5f9', fontWeight: isOpen ? '700' : '400' }}>{cat.name}</span>
                      <FontAwesomeIcon icon={faChevronRight} style={{ transform: isOpen ? 'rotate(90deg)' : 'none', transition: '0.3s', color: isOpen ? goldColor : '#64748b', fontSize: '12px' }} />
                    </div>
                    
                    {isOpen && (
                      <div className="mobile-sub-list" style={{ paddingLeft: '15px', display: 'flex', flexDirection: 'column' }}>
                        {subservices.filter(s => s.category_id === cat.id).map((sub, subIdx) => (
                          <Link key={`sub-mobile-${sub.id}-${subIdx}`} to={`/subservice/${sub.id}`} onClick={closeAll} style={{ padding: '10px 0', fontSize: '14px', color: '#cbd5e1' }}>
                            • {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </nav>
    </header>
    
  );
};

const btnStyle = { 
  background: 'rgba(255, 255, 255, 0.1)',
  border: 'none', 
  padding: '5px 8px', 
  borderRadius: '6px', 
  cursor: 'pointer', 
  fontSize: '11px', 
  fontWeight: 'bold', 
  color: '#cbd5e1'
};

export default Navbar;